var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2124_21265)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76224 0.875C10.0084 0.875 12.6489 3.45722 12.6489 6.63179C12.6489 8.12954 12.0611 9.49557 11.0993 10.5208L12.9919 12.3677C13.169 12.5409 13.1696 12.8211 12.9925 12.9944C12.9042 13.0818 12.7875 13.125 12.6715 13.125C12.556 13.125 12.4399 13.0818 12.3511 12.9955L10.4357 11.1276C9.42813 11.9167 8.15058 12.3892 6.76224 12.3892C3.51606 12.3892 0.875 9.80636 0.875 6.63179C0.875 3.45722 3.51606 0.875 6.76224 0.875ZM6.76224 1.76175C4.01599 1.76175 1.78175 3.94612 1.78175 6.63179C1.78175 9.31747 4.01599 11.5024 6.76224 11.5024C9.50788 11.5024 11.7421 9.31747 11.7421 6.63179C11.7421 3.94612 9.50788 1.76175 6.76224 1.76175Z",
    fill: "#A1A0A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2124_21265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.a81bd452f9eeff89fa2a2e6c09528960.svg";
export { ForwardRef as ReactComponent };